<template>
  <LayoutAdmin :active-periode="activePeriodic">
    <section class="w-full px-8 mt-6">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center">
          <h1 class="text-lg md:text-2xl">Bank Payrun</h1>
          <ChoiseCompany v-if="!loading.company && companies.length"
            @selected:company="company = $event" :options="companies" :dataCompany="company" />
        </div>
        <Button class="px-6 py-2 mx-2 text-white rounded bg-primary h-max" @click="openModal('Create')">Add Bank
          Payrun</Button>
      </div>
    </section>
    <section class="relative w-full p-4 mb-4">
      <Loading v-if="isLoading" />
      <TableBankPayrun :banks-payrun="banksPayrun" @on-edit="onEdit" @on-delete="onDelete" />
      <NoDataShowing v-if="banksPayrun.length === 0 && !isLoading" />
    </section>
  </LayoutAdmin>
  <ModalForm v-show="modal.show" :title="modal.title" :id="formBankPayrun.id" :name-bank="formBankPayrun.nameBank"
    :number-bank="formBankPayrun.numberBank" :is-active="formBankPayrun.isActive" :companies="companies"
    :selected-company="formBankPayrun.selectedCompany" @update:nameBank="(value) => (formBankPayrun.nameBank = value)"
    @update:numberBank="(value) => (formBankPayrun.numberBank = value)" @on-close="closeModal"
    @on-select-company="(value) => (formBankPayrun.selectedCompany = value)" @submit="submitForm" />
</template>

<script>
import LayoutAdmin from "@/components/Layout/Admin.vue";
import TableBankPayrun from "@/components/BankPayrun/TableBankPayrun.vue";
import NoDataShowing from "@/components/NoDataShowing.vue";
import Loading from "@/components/Loading.vue";
import ModalForm from "@/components/BankPayrun/ModalForm.vue";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import { GetPeriodicAPI, GetPeriodicActiveAPI } from "@/actions/periodic";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import {
  getBankPayrun,
  createBankPayrun,
  updateBankPayrun,
  deleteBankPayrun,
} from "@/actions/bank-payrun";
import { useToast } from "vue-toastification";
import Swal from "sweetalert2";

export default {
  name: "BankPayrun",
  components: {
    LayoutAdmin,
    TableBankPayrun,
    Loading,
    NoDataShowing,
    ModalForm,
    ChoiseCompany,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      activePeriodic: "-",
      company: {},
      periodicId: null,
      banksPayrun: [],
      isLoading: true,
      modal: {
        title: "",
        show: false,
      },
      formBankPayrun: {
        id: null,
        nameBank: "",
        numberBank: "",
        isActive: false,
        selectedCompany: null,
      },
      companies: [],
      loading: {
        company: false,
      },
    };
  },
  mounted() {
    this.getAllCompany();
  },
  watch: {
    company: {
      handler() {
        this.getPeriodic();
        this.handleGetPeriodicActive();
      },
      deep: true,
    },
    periodicId: {
      handler() {
        this.getBankPayrun();
      },
    },
  },
  methods: {
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.company?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
    async getAllCompany() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.companies = response?.data;
      this.company = this.companies[0];
      this.loading.company = false;
    },
    getAccountData() {
      const accountData = JSON.parse(localStorage.getItem("accountData"));
      this.company.id = accountData.company_id;
    },
    async getPeriodic() {
      const querySuperAdmin = `?company_id=${this.company._id}`;
      const response = await GetPeriodicAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
        return;
      }

      const periodics = response?.data;
      if (periodics) {
        const filterPeriodic = periodics.filter((period) => {
          return period.periodic_status === true;
        })[0];
        this.periodicId = filterPeriodic?._id;
      }
    },
    async getBankPayrun() {
      this.isLoading = true;
      const { data, success, code, message } = await getBankPayrun({
        companyId: this.company._id,
        periodicId: this.periodicId,
      });
      if (success) {
        const dataBanks = data.map((data) => data.bank);
        this.banksPayrun = dataBanks;
        this.isLoading = false;
      } else {
        if (code === 404) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    openModal(value) {
      this.modal.title = value;
      this.modal.show = true;
    },
    closeModal() {
      this.formBankPayrun = {
        id: null,
        nameBank: "",
        numberBank: "",
        isActive: false,
      };
      this.modal = {
        title: "",
        show: false,
      };
    },
    submitForm() {
      const payload = {
        company_id: this.formBankPayrun.selectedCompany._id,
        bank_name: this.formBankPayrun.nameBank,
        account_number: this.formBankPayrun.numberBank,
      };
      if (this.formBankPayrun.id === null) {
        this.createBankPayrun(payload);
      } else {
        this.updateBankPayrun(payload);
      }
    },
    async createBankPayrun(payload) {
      this.isLoading = true;
      const { message, success, code, errors } = await createBankPayrun(
        payload
      );
      if (success) {
        this.toast.success("Created bank payrun successfully");
        this.modal.title = "";
        this.modal.show = false;
        this.isLoading = false;
        this.getBankPayrun();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code == 400) {
          errors.map((error) => {
            const key = Object.keys(error)[0];
            this.toast.error(error[key]);
          });
        } else {
          this.toast.error(message);
        }
      }
    },
    async updateBankPayrun(payload) {
      const { message, success, code, errors } = await updateBankPayrun({
        id: this.formBankPayrun.id,
        payload,
      });
      if (success) {
        this.toast.success("Updated bank payrun successfully");
        this.modal.title = "";
        this.modal.show = false;
        this.getBankPayrun();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code == 400) {
          errors.map((error) => {
            const key = Object.keys(error)[0];
            this.toast.error(error[key]);
          });
        } else {
          this.toast.error(message);
        }
      }
    },
    onEdit(value) {
      console.log(value);
      this.formBankPayrun.id = value._id;
      this.formBankPayrun.nameBank = value.bank_name;
      this.formBankPayrun.numberBank = value.account_number;
      this.formBankPayrun.isActive = value.is_active;
      this.formBankPayrun.selectedCompany = value.company_id;
      this.modal.title = "Edit";
      this.modal.show = true;
    },
    onDelete(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "For delete this data",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { success, code, message } = await deleteBankPayrun(id);
          if (success) {
            this.toast.success("Deleted bank payrun successfully");
            this.getBankPayrun();
          } else {
            if (code === 401) {
              return this.$router.push("/login");
            } else {
              this.toast.error(message);
            }
          }
        }
      });
    },
  },
};
</script>
